<script setup>
import { inject } from 'vue'

const userStore = inject('userStore')
</script>

<template>
    <a :href="userStore.user ? '/account' : '/login'" :title="userStore.user ? 'Profiel' : 'Inloggen'" class="flex flex-col rounded-full items-center justify-center">
        <icon :name="userStore.user ? 'user' : 'Login03Icon'" class="size-6 text-white"></icon>
        <div class="hidden lg:block mt-1 text-white text-xs font-semibold" v-html="userStore.user ? 'Profiel' : 'Inloggen'"></div>
    </a>
</template>
